<!--
    描述：菜单
    日期：2021/04/29
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success" size="small" icon="el-icon-check"
                               v-if="roleBtns.includes('group_preinstall_role_menu_save')" @click="saveClick()">保存
                    </el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="content" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="tree"
                                 :height="treeObj.tableH"
                                 :data="treeObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                                 @node-click="nodeClick"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/system/menu.js'
    import {saveOrUpdateRoleMenu, getCheckedMenu} from 'api/system/sysGroupRoleMenu.js'

    export default {
        name: '',
        components: {},
        data() {
            return {
                //树默认选中信息
                treeDefaultCheckedKey: [],

                treeObj: {
                    loading: false,
                    tableH: 200,
                    data: [],

                    oriData: [],
                    dataByRoleData: [],
                },
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },

                roleId: '',
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.treeObj.tableH = this.$refs.content.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.treeObj.tableH = this.$refs.content.offsetHeight;
            }
        },
        created() {
            //获取菜单信息
            this.getMenuTreeTableData();
        },
        methods: {
            init(obj) {
                this.treeDefaultCheckedKey = []
                this.treeObj.data = this.treeObj.oriData.concat()

                this.roleId = obj.roleId
                if (obj.roleId == '') return

                //获取权限菜单数据
                this.getCheckedMenu()
            },
            //获取菜单信息
            getMenuTreeTableData() {
                let that = this
                selectTree({isSys: 1}).then(res => {
                    if (res.operationCode == 1) {
                        that.treeObj.oriData = res.data;
                        that.treeObj.data = that.treeObj.oriData.concat()
                    }
                });

            },
            getCheckedMenu() {
                let that = this
                let param = {
                    roleId: that.roleId,
                }
                getCheckedMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        this.treeDefaultCheckedKey = res.data
                    }
                })
            },
            saveClick() {
                let that = this
                if (that.roleId == '') {
                    that.$message({message: '请选择角色信息', type: 'warning'});
                    return;
                }

                let menuIdsSelection = [];
                let checkSelection = this.$refs.tree.getCheckedKeys().concat()
                let param = {
                    roleId: that.roleId,
                    menuIdsSelection: checkSelection
                }
                saveOrUpdateRoleMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        that.$message({message: '保存成功', type: 'success'});
                    }
                });
            },
            //节点点击
            nodeClick(obj) {
                this.$emit('row-click', obj)
            },
        }
    }
</script>
<style lang="less">

</style>